/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description Patient event Constants
 */

// Generic actions
export const GET_ALL_PATIENT_EVENTS = 'Profile/GET_ALL_PATIENT_EVENTS';
export const GET_PATIENT_EVENT_BY_ID = 'Profile/GET_PATIENT_EVENT_BY_ID';
export const CREATE_PATIENT_EVENT = 'Profile/CREATE_PATIENT_EVENT';
export const UPDATE_PATIENT_EVENT = 'Profile/UPDATE_PATIENT_EVENT';
export const DELETE_PATIENT_EVENT_BY_ID = 'Profile/DELETE_PATIENT_EVENT_BY_ID';
export const GET_ALL_EVENT_TYPES = 'Profile/GET_ALL_EVENT_TYPES';
